'use strict';

app.controller('DriversCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $ngConfirm, toaster) {
        $scope.LIST_TAB = 1;
        $scope.ASSOCIATIONS_TAB = 2;

        $scope.tab = $scope.LIST_TAB;

        $scope.changeTab = function(v) {
            $scope.resetForm();
            $scope.tab = v;
        };

        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        $scope.loading = false;
        $scope.expanded = false;

        $scope.form = {};
        $scope.initialForm = angular.copy($scope.form);

        $scope.drivers = [];

        $scope.resetForm = function() {
            $scope.form = angular.copy($scope.initialForm);
        };

        $scope.afterFormAction = function() {
            $scope.resetForm();
            $scope.list();
            $scope.isExpandedForm() && $scope.toggleExpandedForm();
        };

        $scope.toggleExpandedForm = function() {
            $scope.expanded = !$scope.expanded;
        };

        $scope.isExpandedForm = function() {
            return $scope.expanded === true;
        };

        $scope.editModeEntry = false;

        $scope.isInEditMode = function(driver) {
            return $scope.editModeEntry.DriverId === driver.DriverId;
        };

        var old = null;

        $scope.goToEditMode = function(driver) {
            $scope.editModeEntry = $scope.prepareEditModeEntry(driver);

            old = angular.copy($scope.editModeEntry);
        };

        $scope.prepareEditModeEntry = function(driver) {
            var iButtonData = { on: false };
            var rfidData = { on: false };
            var tachoDriverData = { on: false };

            if (driver.IButtonId) {
                iButtonData.on = true;
                iButtonData.value = driver.IButtonId;
                iButtonData.date = driver.IButtonRemoveTime;
            }

            if (driver.TachoDriverId) {
                tachoDriverData.on = true;
                tachoDriverData.value = driver.TachoDriverId;
                tachoDriverData.date = driver.TachoRemoveTime;
            }

            return {
                DriverId: driver.DriverId,
                Name: driver.Name,
                GsmNumber: driver.GsmNumber,
                Notes: driver.Notes,
                TachoDriverData: tachoDriverData,
                IButtonData: iButtonData,
                RFIDData: rfidData,
            };
        };

        $scope.cancelEditMode = function() {
            $scope.editModeEntry = false;

            old = null;
        };

        $scope.driverStateChanged = function(form, v) {
            if (!form[v].on) {
                form[v].value = null;
                form[v].date = null;
            }

            return false;
        };

        $scope.validate = function(payload) {
            /**
             * @TODO
             */
            return true;
        };

        $scope.create = function() {
            var payload = $scope.form;

            if (!$scope.validate(payload)) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.toastr.error.form.validation.fill')
                );

                return false;
            }

            $http.post('/api/driver/create', { new: payload, old: null }).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.save')
                    );

                    $scope.afterFormAction();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.save')
                    );
                }
            );

            return true;
        };

        $scope.buildUpdatePayload = function() {
            var payload = angular.copy($scope.editModeEntry);

            return payload;
        };

        $scope.update = function(driver) {
            var payload = $scope.buildUpdatePayload();

            if (!$scope.validate(payload)) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.toastr.error.form.validation.fill')
                );

                return false;
            }

            $http.put('/api/driver/update', { new: payload, old }).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.update')
                    );

                    $scope.afterFormAction();
                    $scope.cancelEditMode();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.update')
                    );
                }
            );
            return true;
        };

        $scope.delete = function(id) {
            $http.post('/api/driver/delete', { id: id }).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.delete')
                    );

                    $scope.list();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.delete')
                    );
                }
            );

            return true;
        };

        $scope.list = function() {
            $scope.loading = true;
            $scope.drivers = [];

            $http.get('/api/driver/list').then(
                function(response) {
                    var drivers = (response.data.data || {}).drivers;
                    $scope.drivers = drivers !== void 0 ? drivers : [];

                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.init = function() {
            $scope.list();
        };

        $scope.init();

        $scope.deleteConfirmation = function(driver) {
            $ngConfirm({
                title: $translate.instant('general.confirm.delete.title'),
                content: $translate.instant('general.confirm.delete.content') + '<b> (' + driver.Name + ') </b>',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-trash pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.delete.yes'),
                        btnClass: 'btn-danger',
                        action: function(scope) {
                            scope.delete(driver.DriverId);

                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.delete.no'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };
    },
]);
